import React from "react"
import { Section } from "src/utils"
import { Container } from "src/layout/container/Container"
import cn from "classnames"
import Icon, { IconType } from "src/components/icon/Icon"
import { ThemeColor } from "../../sanity/types"
import s from "./UspModule.module.scss"

interface ChecklistItem {
    body: string
    icon: IconType
    id: string
}

export interface UspModuleProps {
    items: ChecklistItem[]
    backgroundColor?: ThemeColor
    contrastColor?: ThemeColor
    textColor?: ThemeColor
}

export default function UspModule({
    items,
    backgroundColor = "sky",
    contrastColor = "night",
    textColor = "black",
}: UspModuleProps): JSX.Element {
    return (
        <Section>
            <div className={cn(`bg-${backgroundColor}`, s["usp-module"])}>
                <Container>
                    <ul className={s["usp-module__list"]}>
                        {items.map(item => {
                            return (
                                <li key={item.id} className={cn(s["usp-module__item"])}>
                                    <span className={cn(s["usp-module__icon"], `text-${contrastColor}`)} >
                                        <Icon fill type={item.icon || IconType.ARROW_TOP_RIGHT} />
                                    </span>

                                    <p className={cn(s["usp-module__list__item__title"], "label-300", `text-${textColor ? textColor : contrastColor}`)} >{item.body}</p>
                                </li>
                            )
                        })}
                    </ul>
                </Container>
            </div>
        </Section>
    )
}
